import { useQuery } from '@tanstack/react-query';

import type { Shops } from '@/Swagger';
import axiosInstance from '@/axios/axios';
import type { UseAxiosQueryOptions } from '@/utils/typeHelper';

import { 매니저전용_쿼리키 } from './manager-query-keys';

type QueryOptions = UseAxiosQueryOptions<
  Shops.ShopsList.ResponseBody,
  [string, { searchParams?: Shops.ShopsList.RequestQuery }]
>;

/**
 * 샵 목록을 조회하는 API 입니다.
 * @see https://kr-api-qa.acloset.net/shops/swagger/index.html#/Shops/get_shops
 */
export function useGetShops(searchParams?: Shops.ShopsList.RequestQuery, options?: Partial<QueryOptions>) {
  return useQuery({
    queryKey: [...매니저전용_쿼리키.샵목록, { searchParams }] as const,
    queryFn: ({ queryKey }) => {
      const [, { searchParams }] = queryKey;

      return axiosInstance.get<Shops.ShopsList.ResponseBody>('/shops', { params: searchParams }).then(v => v.data);
    },
    ...options,
  });
}
